/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import {
  styled,
  IconButton,
  DialogTitle,
  Typography,
  Checkbox,
  Button,
  DialogContentText,
} from "@mui/material";

export const StyledIconContainer = styled("div")({
  display: "flex",
  justifyContent: "center",
  marginTop: "35px",
});

export const StyledIconButton = styled(IconButton)({
  "&:hover": {
    background: "transparent !important",
  },
  border: "3px solid #5069c3",
  cursor: "default",
});

export const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: "600",
  fontSize: "18px",
});

export const StyledConfirmMessage = styled(Typography)({
  paddingTop: "10px",
  fontSize: "15px",
  color: "#535353",
});

export const StyledCheckbox = styled(Checkbox)({
  "&.Mui-checked": {
    color: "#e95420",
  },
  padding: "9px 9px 9px 0px !important",
});

export const StyledConfirmDeleteContainer = styled("div")({
  display: "flex",
  gap: "5px",
  marginTop: "10px",
});

export const StyledConfirmButton = styled(Button)({
  "&:hover": {
    backgroundColor: " #395bbd !important",
  },
  fontSize: "13px",
  textTransform: "none",
  backgroundColor: "#395bbd",
  borderRadius: "8px",
  boxShadow: "none !important",
  fontWeight: "600",
});

export const StyledCancelButton = styled(Button)({
  "&:hover": {
    backgroundColor: "#e0e0e0",
  },
  fontSize: "13px",
  textTransform: "none",
  borderRadius: "8px",
  fontWeight: "600",
  color: "#395bbd",
});

export const StyledDialogContentText = styled(DialogContentText)({
  fontSize: "16px",
  color: "#535353",
})
